import React from 'react';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';
import type { colors } from '../../../theme/axiom-theme';
import { ColorUtil } from '../../../utils/color-util';

export type FlashyProps = {
  children?: React.ReactNode;
  backgroundColor?: keyof typeof colors;
  bold?: boolean;
  color?: keyof typeof colors;
  italic?: boolean;
  name?: string;
  strikethrough?: boolean;
  underline?: boolean;
};

export const Flashy = ({
  backgroundColor,
  bold,
  children,
  color,
  italic,
  name,
  strikethrough,
  underline,
}: FlashyProps) => (
  <span
    className={AttrsHelper.formatClassname(
      'axiom-flashy',
      ColorUtil.tokenClass({ prefix: 'background', color: backgroundColor }),
      ColorUtil.tokenClass({ prefix: 'color', color }),
      bold && 'flashy-bold',
      italic && 'flashy-italic',
      strikethrough && 'flashy-strikethrough',
      underline && 'flashy-underline'
    )}
    data-test={name}
  >
    {children}
  </span>
);
